export default function EntryHeader({ noun, count, onAdd }) {
  const plural = count === 1 ? noun : `${noun}s`
  return (
    <div className="entry-header">
      <span className="entry-header-count">
        {count} {plural} added
      </span>
      <button type="button" className="entry-header-add" onClick={onAdd}>
        + Add another {noun}
      </button>
    </div>
  )
}
